import BaseAsyncSelect from 'components/Filters/BaseAsyncSelect'
import { API_TRAINING_THEMES } from 'constants/api-v2'
import { useI18n } from 'context/I18nProvider'
import { getId } from 'services/apiPlatform'

export default function Themes({ ...props }) {
  const { i18name } = useI18n()

  return (
    <BaseAsyncSelect
      name="theme"
      label="label.themes"
      url={API_TRAINING_THEMES}
      mapper={(opt: any) => ({ ...opt, label: i18name(opt), value: getId(opt) })}
      apiPlatform
      {...props}
    />
  )
}
